import React from "react";
import Container from "@/components/marketing/Container";
import Reveal from "@/components/marketing/Reveal";

const TESTIMONIALS = [
  {
    quote: "Digital24 got our Series A announcement on Yahoo Finance and 40+ outlets within 24 hours. The coverage directly contributed to investor interest in our round.",
    initials: "SK",
    name: "Sarah K.",
    role: "CEO, FinTech Startup — London, UK",
  },
  {
    quote: "We've tried three PR distribution services. Digital24 is the only one that consistently delivers Google News indexing and real, verifiable published links. Worth every dirham.",
    initials: "AR",
    name: "Ahmed R.",
    role: "Marketing Director — Dubai, UAE",
  },
  {
    quote: "As a crypto exchange, finding PR distribution that actually accepts our industry is hard. Digital24 not only accepted us but placed us on CoinDesk and CoinTelegraph.",
    initials: "MT",
    name: "Michael T.",
    role: "Head of Communications — Hong Kong, SAR",
  },
];

export default function Testimonials() {
  return (
    <section className="py-11 lg:py-12 border-t border-[rgba(28,28,32,0.06)]">
      <Container>
        {/* Heading */}
        <Reveal>
          <div className="text-center mb-10">
            <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-3.5">Testimonials</div>
            <h2 className="font-heading text-[clamp(32px,4vw,46px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-3.5 text-heading-gradient">
              Trusted by teams like yours.
            </h2>
            <p className="text-[16px] leading-[1.55] text-[#6c6c74] max-w-[480px] mx-auto">
              From fintech startups to luxury real estate, our clients rely on Digital24 for credible, measurable media coverage.
            </p>
          </div>
        </Reveal>

        {/* Testimonial cards */}
        <div className="grid md:grid-cols-3 gap-[22px] items-start">
          {TESTIMONIALS.map((q, i) => (
            <Reveal variant="card" delay={i * 0.08} key={i}>
              <figure
                className="glass-card flex flex-col gap-[18px] p-7 lg:p-[30px]"
                style={{ borderRadius: 28 }}
              >
              <blockquote className="text-[14.5px] leading-[1.6] text-[#55555c] m-0">
                "{q.quote}"
              </blockquote>
              <figcaption className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-brand-gradient text-white text-[12px] font-bold">
                  {q.initials}
                </span>
                <span className="flex flex-col">
                  <span className="text-[13.5px] font-[650] text-[#1c1c20] whitespace-nowrap">{q.name}</span>
                  <span className="text-[12px] text-[#8e8e96] whitespace-nowrap">{q.role}</span>
                </span>
              </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}